import { render, staticRenderFns } from "./CategoryDictionariesNew.vue?vue&type=template&id=b4aa8f6e&scoped=true&"
import script from "./CategoryDictionariesNew.vue?vue&type=script&lang=js&"
export * from "./CategoryDictionariesNew.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDictionariesNew.vue?vue&type=style&index=0&id=b4aa8f6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4aa8f6e",
  null
  
)

export default component.exports